import { Injectable } from '@angular/core';
import { DateConverter } from '@shared-helpers/dateConverter';
import { BaseHttpService } from '@shared-services/base-http-service';
import { Observer } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

declare function gtag(...args: any[]): void;
declare var fourdGoogleAnalyticsProfile: string | undefined;
declare var fourdGoogleAnalyticsClientId: string | undefined;
declare var fourdGoogleAnalyticsCookieConsentPreviouslyGiven: string | undefined;

@Injectable({
  providedIn: 'root' // Single instance provided in root
})
export class GoogleAnalyticsService extends BaseHttpService {

  private serviceRootUrl = '/GoogleAnalytics/';

  constructor() { super("GoogleAnalyticsService") }

  logCookieDataConsent(googleAdUserDataConsentGiven: boolean, observerOrNext?: Partial<Observer<boolean>> | ((value: boolean) => void)): void {
    let url: string = `${this.serviceRootUrl}LogCookieDataConsent`;
    let body: string = JSON.stringify({ googleAdUserDataConsentGiven: googleAdUserDataConsentGiven });
    let options = this.httpOptions;
    this.http?.post<boolean>(url, body, options).pipe(
      timeout(this.httpTimeout),
      map((item) => DateConverter.stringsToDates(item)),
      catchError(this.errorService?.handleHttpError<boolean>(url, body, options, this))
    ).subscribe(observerOrNext);
  }

  logClientId(clientId: string, observerOrNext?: Partial<Observer<boolean>> | ((value: boolean) => void)): void {
    let url: string = `${this.serviceRootUrl}LogClientId`;
    let body: string = JSON.stringify({ clientId: clientId });
    let options = this.httpOptions;
    this.http?.post<boolean>(url, body, options).pipe(
      timeout(this.httpTimeout),
      map((item) => DateConverter.stringsToDates(item)),
      catchError(this.errorService?.handleHttpError<boolean>(url, body, options, this))
    ).subscribe(observerOrNext);
  }

  private gtagFunctionDefined(): boolean {
    return typeof gtag === 'function';
  }

  private fourdGoogleAnalyticsProfileVariableDefined(): boolean {
    return typeof fourdGoogleAnalyticsProfile !== 'undefined';
  }

  private fourdGoogleAnalyticsClientIdVariableDefined(): boolean {
    return typeof fourdGoogleAnalyticsClientId !== 'undefined';
  }

  private fourdGoogleAnalyticsCookieConsentPreviouslyGivenVariableDefined(): boolean {
    return typeof fourdGoogleAnalyticsCookieConsentPreviouslyGiven !== 'undefined';
  }

  emitEvent(eventName: string, eventCategory: string, eventAction: string, eventLabel: string = null, eventValue: number = null) {
    if (this.gtagFunctionDefined()) {
      gtag('event', eventName, {
        'event_action': eventAction,
        'event_category': eventCategory,
        'event_label': eventLabel,
        'value': eventValue
      });
    }
  }

  emitConsentGranted() {
    if (this.gtagFunctionDefined()) {
      // Set consent parameters
      gtag('consent', 'update', {
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
        'analytics_storage': 'granted'
      });
      // Switch off URL passthrough now we have cookie consent
      gtag('set', 'url_passthrough', false);
    }
  }

  checkForClientId() {
    if (this.fourdGoogleAnalyticsClientIdVariableDefined() && !(fourdGoogleAnalyticsClientId?.length > 0)) {
      // Google Analytics ClientId is unknown
      if (this.gtagFunctionDefined() && this.fourdGoogleAnalyticsProfileVariableDefined()) {
        var thisClass = this;
        // Get ClientId
        gtag('get', fourdGoogleAnalyticsProfile, 'client_id', function (cid: string) {
          if (cid?.length > 0) {
            // Log ClientId
            thisClass.logClientId(cid);
          }
        });
      }
    }
  }

}
